<widget-header
  [name]="widgetName"
  (onRenamed)="renameWidget($event)">
  <widget-wp-table-menu
    slot="menu"
    [resource]="resource">
  </widget-wp-table-menu>
</widget-header>

<div class="op-widget-box--body">
  <wp-embedded-table [queryId]="queryId"
                     [configuration]="configuration"
                     *ngIf="queryId">
  </wp-embedded-table>
</div>
